import { ChallengeService } from "services";
import { ChallengeThemePersonnaliseImage } from "./ChallengeThemePersonnaliseImage.class";
import { ChallengeTheme } from "./ChallengeTheme.class";
import { DeepRawify } from "types";
import { DeepPartial } from "redux";

export class ChallengeThemePersonnalise extends ChallengeTheme {

    public idThemePersonnalise : number = null;

    public libelle : string = null;

    public actif : number = null;

    public images : ChallengeThemePersonnaliseImage[] = null

    private ChallengeService = ChallengeService.getInstance();

    constructor(row? : DeepPartial<DeepRawify<ChallengeThemePersonnalise>>) {
        super(row)
        if (row) {

            const {
                idThemePersonnalise,
                libelle,
                actif,
                images
            } = row;

            this.idThemePersonnalise = idThemePersonnalise;

            this.libelle = libelle;

            this.actif = actif;

            if (images) {
                this.images = images.map((image) => new ChallengeThemePersonnaliseImage(image));
            }

        }
    }

    // public save : () => Promise<boolean> = () => {
    //     return this.ChallengeThemeService.saveChallengeTheme(this);
    // }

    public toDatabaseObject(): object {
        return {
            idThemePersonnalise: this.idThemePersonnalise,
            libelle: this.libelle,
            actif : this.actif
        }
    }
}